import React from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";
import { pluralize } from "../../../../../common/helpers/helpers";

const tdCl = "tw-px-1 tw-border border-normal";
const thCl = "tw-min-w-6 tw-px-1 tw-border border-normal tw-h-4 tw-relative";
const thContentCl = "tw-absolute tw-inset-0 tw-px-1 tw-truncate";

function HaploTriploTable({ type, score, desc, pubs }) {
  const noData = score === null && desc === null && pubs.length === 0;
  if (noData) return null;
  return (
    <table className="tw-w-full tw-my-2">
      <thead>
        <tr className="tw-bg-blueGray-400 tw-bg-opacity-20 tw-font-bold">
          <th
            className={`${thCl}`}
            data-tooltip={type}
            data-tooltip-class="genome-browser-small-tooltip"
          >
            <div className={thContentCl}>{type}</div>
          </th>

          <th
            className={`${thCl} tw-w-16`}
            data-tooltip="Score"
            data-tooltip-class="genome-browser-small-tooltip"
          >
            <div className={thContentCl}>Score</div>
          </th>
          <th
            className={`${thCl} tw-w-16`}
            data-tooltip="Pubmed"
            data-tooltip-class="genome-browser-small-tooltip"
          >
            <div className={thContentCl}>PubMed</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={`${tdCl} tw-break-all`}>{desc ?? "-"}</td>
          <td className={tdCl}>{score ?? "-"}</td>
          <td className={tdCl}>
            <PublicationLinks
              ids={pubs}
              className="tw-text-blue-500 tw-cursor-pointer"
            >
              {pubs?.length} {pluralize(pubs?.length, "PMID", "PMIDs")}
            </PublicationLinks>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

HaploTriploTable.propTypes = {
  type: PropTypes.string.isRequired,
  desc: PropTypes.string,
  score: PropTypes.number,
  pubs: PropTypes.arrayOf(PropTypes.string),
};

HaploTriploTable.defaultProps = {
  desc: null,
  score: null,
  pubs: [],
};

export default HaploTriploTable;
